<!--表格组件 -->
<template>
  <section class="ces-table-page">
    <!-- 表格操作按钮 -->
    <!-- 数据表格 -->
    <section class="ces-table">
      <el-table
        :row-key="(row)=>{return row.userId}"
        :data="tableData"
        :size="size"
        :max-height="maxHeight"
        :border="isBorder"
        :reviewId="reviewId"
        :activeTab="activeTab"
        @select="select"
        @select-all="selectAll"
        v-loading="loading"
        @sort-change="changeSort"
        @row-dblclick="(row, column, event)=>{rowDblClick(row, column, event,editList)}"
        fit
        style="width:100%"
        ref="cesTable"
        :header-cell-style="{'background-color': '#1e87f1','height':'45px','color':'#fff'}"
        :header-row-class-name="headerRowClassName"
        :row-class-name="tableRowClassName"
        :row-style="selectedstyle"
        :cell-class-name="rowClass"
        :span-method="spanMethod"
        :show-summary="summary"
        :summary-method="getSummaries"
      >
        <el-table-column v-if="isSelection" type="selection" align="center" width="50"></el-table-column>
        <el-table-column v-if="isIndex" type="index" :label="indexLabel" align="center" width="80"></el-table-column>
        <!-- 数据栏 -->
        <!-- 多级表头 暂通过resizable 标识 （针对批量录题时只做表格展示--第X列，无操作）-->
        <el-table-column
          v-for="(item, index) in tableCols"
          v-show="item.show === true"
          :resizable="item.resizable"
          :key="item.id"
          :prop="item.prop"
          :label="!item.resizable?`第${index+1}列`:item.label"
          :width="item.width"
          :align="item.align"
          :fixed="item.type=='Button'||item.type=='ButtonReview'?'right':null"
          :render-header="item.require?renderHeader:null"
          :sortable="item.sortable"
          :show-overflow-tooltip="true"
        >
          <el-table-column v-if="!item.resizable" :label="item.label" :prop="item.prop" :align="item.align">
          <template #header>
            <span><sup v-if="item.required" style="color:red">*</sup>{{item.label}}</span>
          </template>
          </el-table-column>
          <template slot-scope="scope">
            <!-- 按钮 -->
            <span v-if="item.type==='Button'">
              <span>
                <span
                  class="operation"
                  :class="[(btn.formatterClass && btn.formatterClass(scope.row,btn.prop,scope.row[btn.prop])) || btn.itemClass,
                  scope.row.question_status==0&&btn.handleThis=='edit'?'canotHandle':'']"
                  v-for="(btn,index) in item.btnList"
                  :key="index"
                  @click="btn.handle(scope.row,scope.$index)"
                  v-auth="btn.auth"
                >
                  <span>{{(btn.formatter && btn.formatter(scope.row,btn.prop,scope.row[btn.prop])) || btn.label}}</span>
                </span>
              </span>
            </span>
            <span v-else-if="item.type==='Button-btn'">
              <el-button
                v-for="(btn,index) in item.btnList"
                :key="scope.$index+''+index"
                size="mini"
                :type="btn.type"
                @click="btn.handle(scope.row,scope.$index)"
                :disabled="btn.disabled?btn.disabled(scope.row,btn.prop,scope.row[btn.prop]):false"
                v-auth="btn.auth"
              >{{(btn.formatter && btn.formatter(scope.row,btn.prop,scope.row[btn.prop])) || btn.label}}</el-button>
            </span>
            <!-- 非按钮 -->
            <div v-else>
              <!-- 编辑 -->
              <div class="edit-input" v-if="item.isEdit">
                <el-input
                  v-model="tableData[scope.$index][item.prop]"
                  placeholder="值"
                  style="width: 100%"
                  @blur="blurEdit($event)"
                  size="small"
                ></el-input>
              </div>
              <!-- 普通单元格 -->
              <!-- 文本超出两行省略号显示 -->
              <span v-else-if="item.type=='icon'">
                <i class="el-icon-medal" v-if="scope.row[item.prop]"></i>
                <span v-else>--</span>
              </span>
              <span
                v-else
                style="display: inherit;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;"
              >{{(item.formatter && item.formatter(scope.row,item.prop,scope.row[item.prop])) || scope.row[item.prop] || '--'}}</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 分页 -->
    <section class="ces-pagination" v-if="isPagination">
      <el-pagination
        background
        style="display: flex;justify-content: center;height: 100%;align-items: center;"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page="pagination.page"
        :page-sizes="[10, 20, 50]"
        :page-size="pagination.size"
        layout="total, sizes,prev, pager, next, jumper"
        :total="pagination.total"
      ></el-pagination>
    </section>
  </section>
</template>

<script>
import { addClass, removeClass } from '../../utils';
var elementResizeDetectorMaker = require('element-resize-detector');
export default {
  name: 'tablePage',
  props: {
    // 表格型号：mini,medium,small
    size: { type: String, default: 'medium' },
    isBorder: { type: Boolean, default: true },
    summary: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    // 表格操作
    isHandle: { type: Boolean, default: false },
    reviewId: { type: Number, default: 0 },
    activeTab: {type: String, default: '0'},
    // 表格数据
    tableData: { type: Array, default: () => [] },
    getSummaries: { type: Function, default: () => {} },
    // 表格列配置
    tableCols: { type: Array, default: () => [] },
    // 是否显示表格复选框
    isSelection: { type: Boolean, default: false },
    // 是否显示表格索引
    isIndex: { type: Boolean, default: false },
    // 是否可选
    isSelectable: { type: String, default: '' },
    indexLabel: { type: String, default: '序号' },
    // 是否显示分页
    isPagination: { type: Boolean, default: true },
    // 分页数据
    pagination: {
      type: Object
    },
    // 可行内编辑字段
    editList: {
      type: Array,
      default: () => []
    },
    // 单元格的样式
    rowClass: {
      type: Function,
      default: () => {}
    },
    // 合并行列方法
    spanMethod: {
      type: Function,
      default: () => {}
    },
    // 多选清空
    clearSelection: {
      type: Boolean, default: false
    },
    showMaxHeight: {
      type: Boolean, default: false
    }
  },
  data () {
    return {
      maxHeight: 0,
      getIndex: null // 被点击行下标
      // currentRow: null // 被点击行数据
    }
  },
  watch: {
    clearSelection (a, b) {
      if (b) {
        this.$refs.cesTable.clearSelection();
      }
    }
  },
  methods: {
    blurEdit (event) {
      removeClass(event.path[3], 'edit-col')
    },
    // 行点击
    rowDblClick (row, column, event, editList) {
      if (editList.indexOf(column.property) !== '-1') {
        addClass(event.target, 'edit-col')
      }
    },
    // 表格勾选
    select (rows, row) {
      this.$emit('update:select', rows)
    },
    // 全选
    selectAll (rows) {
      this.$emit('update:select', rows)
    },
    handleCurrentChange (val) {
      this.rowClick('') // 跨页清空选中状态
      this.$emit('update:pagination', { ...this.pagination, page: val })
    },
    handleSizeChange (val) {
      this.rowClick('') // 跨页清空选中状态
      this.$emit('update:pagination', { ...this.pagination, rows: val })
    },
    changeSort (val) {
      this.$emit('changeSort', val)
    },
    renderHeader (h, obj) {
      return h('span', { class: 'ces-table-require' }, obj.column.label);
    },
    // 设置行对象(row)的样式(style)
    selectedstyle ({ row, rowIndex }) {
      if (this.getIndex === rowIndex) {
        return {
          'background-color': 'oldlace'
        };
      }
    },
    // 为行对象(row)设置index属性
    tableRowClassName ({ row, rowIndex }) {
      row.index = rowIndex;
    },
    headerRowClassName ({ row, rowIndex }) {
      return `header-row-className${rowIndex}`
    },
    // 行点击事件,这里获取到的行对象(row)是没有index属性的
    rowClick (row) {
      this.getIndex = row.index;
      // this.currentRow = row
    }
  },
  mounted () {
    var erd = elementResizeDetectorMaker();
    let _this = this
    this.$nextTick(() => {
      this.maxHeight = document.body.offsetHeight - 240;
      erd.listenTo(this.$refs.cesTable.$refs.bodyWrapper.firstChild, function (element) {
        if ((element.clientWidth > _this.$refs.cesTable.$refs.bodyWrapper.clientWidth) && _this.$refs.cesTable.$refs.rightFixedWrapper) {
          _this.$refs.cesTable.$refs.rightFixedWrapper.style.bottom = '10px'
        }
        if ((element.clientHeight >= _this.maxHeight) && _this.$refs.cesTable.$refs.rightFixedWrapper) {
          _this.$refs.cesTable.$refs.rightFixedWrapper.style.right = '10px'
        } else {
          if (_this.$refs.cesTable.$refs.rightFixedWrapper) _this.$refs.cesTable.$refs.rightFixedWrapper.style.right = '0'
        }
      });
    });
  }
};
</script>
<style lang="scss" scoped>
.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li {
  background: none;
}

.el-table__body-wrapper::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #ebedf5;
  border-radius: 5px;
}

.ces-table .el-table__fixed-body-wrapper {
  height: calc(100% - 43px) !important;
}
/deep/.el-table .descending .sort-caret.descending {
  border-top-color: #fff;
}
/deep/ .el-table .ascending .sort-caret.ascending {
  border-bottom-color: #fff;
}
/deep/ .el-table--mini, .el-table--small, .el-table__expand-icon{
  font-size: 14px;
  font-weight: 500;
}
/deep/ .el-checkbox__inner{
  border: 2px solid #DCDFE6;
  width: 18px;
  height: 18px;
}
/deep/ .el-table .cell.el-tooltip{
  white-space: normal;
}
.el-table__row.edit-row {
  height: 50px;
}
.el-table .redClass {
  color: red;
}
.btn {
  display: inline-block;
  background: #4093ff;
  color: #fff;
  padding: 1px 8px;
  border-radius: 3px;
  margin: 5px;
}
.ces-table-require::before {
  content: "*";
  color: red;
}
.reviewCell{
  display: flex;
  align-items: center;
  justify-content: center;
}
.operation {
  cursor: pointer;
  padding: 0 5px;
}
.ces-pagination {
  margin-top: 20px;
}
.ces-table-page {
  // padding-top: 10px;
  // margin-left: 20px;
}
.operation.green {
  color: #95d1a3;
}
.operation.red {
  color: #ff0000;
}
.operation.blue {
  color: #409eff;
}
.operation.orange {
  color: #f56c6c;
}
.operation.btnGrey {
  color: #cccccc;
}
.edit-input {
  display: none;
}
.edit-col .edit-input {
  display: block;
}
.edit-col .read {
  display: none;
}
.content-overflow{
  overflow:hidden;
  white-space: nowrap;
  text-overflow:ellipsis;
  // display:-webkit-box;
  // -webkit-line-clamp:2; // 元素几行显示
  // -webkit-box-orient:vertical;
}
.redClass {
  color: red;
  background: #000;
}

.audit_btn {
  margin-left: 5px;
  padding: 1px 6px;
  border-radius: 2px;
  background: rgb(0, 122, 225);
  color: white;
}
.operation.canotHandle{
  color: #ccc;
  cursor: not-allowed;
}
.isCollect {
  background-color: #0f85e8;
  color: #fff;
  padding: 3px 6px;
  border-radius: 4px;
  font-size: 12px;
}
.cancelCollect{
  color: #999;
}
.goods{
  display: inline-block;
  width: 25px;
  height: 25px;
  background-size: 100%;
  vertical-align: bottom;
}
.el-icon-medal{
  color: #00a1e1;
  font-size: 21px;
}
</style>
<style>
.el-table .warning-row {
  background: oldlace;
}
.header-row-className1 th {
  background-color: #ECF5FE !important;
  color: #666 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/tablePage.vue